import { lazy } from 'react';

const Row = lazy(() => import('./Row'));

export { Row };
